import {useMemo} from '@wordpress/element';
import {getFilterChip} from "./Filters";
import {useCatalog} from "../../store/catalog";

export function ActiveFilters() {
    const {
        filterConfigs,
        filterValues,
        search,
        setSearch,
        removeFilter,
        removeFilterValue,
        resetFilters,
    } = useCatalog();

    const activeFilters = useMemo(() => {
        const chips = [];

        // Search chip
        if (search) {
            chips.push({
                id: 'search',
                label: `Search: ${search}`,
                onRemove: () => setSearch(''),
            });
        }

        filterConfigs.forEach(config => {
            const value = filterValues[config.id];
            if (value == null) return;
            if (config.type === 'checkbox' && !value) return;
            if (config.type === 'rating' && (value === 0 || value === '0')) return;
            if (config.type !== 'checkbox' && Array.isArray(value) && value.length === 0) return;
            if (config.type !== 'checkbox' && !Array.isArray(value) && !value) return;

            // Categories — bypass chipHidden and build manually
            if (config.type === 'category') {
                if (value?.name) {
                    chips.push({
                        id: 'categories',
                        label: `Category: ${value.name}`,
                        onRemove: () => removeFilter('categories'),
                    });
                }
                return;
            }

            const labelOrChips = getFilterChip(config, value);
            if (Array.isArray(labelOrChips)) {
                labelOrChips.forEach(chip => {
                    const label = (config.type === 'multi-checkbox' || config.type === 'search')
                        ? chip.label
                        : `${config.label}: ${chip.label}`;
                    chips.push({
                        id: `${config.id}-${chip.value}`,
                        label,
                        onRemove: () => removeFilterValue(config.id, chip.value),
                    });
                });
            } else if (labelOrChips) {
                chips.push({
                    id: config.id,
                    label: labelOrChips,
                    onRemove: () => removeFilter(config.id),
                });
            }
        });

        return chips;
    }, [filterConfigs, filterValues, search]);

    if (activeFilters.length === 0) return null;

    return (
        <div className="flex-1 my-auto">
            <div className="flex flex-wrap gap-2 items-center">
                <span className="text-[10px] font-black pt-dark-blue uppercase tracking-widest mr-2">
                    Active Filters
                </span>

                {activeFilters.map(filter => (
                    <div
                        key={filter.id}
                        className="bg-primary text-white gap-2 py-1.5 px-3 font-bold rounded-full transition-all flex items-center"
                    >
                        <span className="text-[10px] uppercase tracking-wider">{filter.label}</span>
                        <button
                            onClick={filter.onRemove}
                            className="hover:opacity-80 transition-opacity ml-1"
                            aria-label={`Remove ${filter.label} filter`}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none"
                                 viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="4"
                                      d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                        </button>
                    </div>
                ))}

                {activeFilters.length > 1 && (
                    <button
                        onClick={resetFilters}
                        className="btn btn-sm btn-ghost text-error font-bold hover:bg-error/10 ml-2 rounded-full"
                    >
                        Clear All
                    </button>
                )}
            </div>
        </div>
    );
}